import React from "react";
import styled from "styled-components";
import { shorten } from "@backpacker/number";
import { content, evolution } from "@glossy/theme";
import { GlossyTheme } from "@glossy/theme/types";
import { tr } from "@linkfluence/i18n";
import { Locale } from "@linkfluence/models/locale";
import { isValid } from "@tootools/number";

const formatEvolution = (
  evolution: number,
  locale: Locale,
  knowable: boolean,
  compact: boolean,
  percentagePoint?: boolean
) => {
  if (!isValid(evolution)) return knowable ? " " : "N/A";
  if (evolution === 0) return "\u003D";
  if (!compact) {
    const unit = percentagePoint
      ? tr(locale, "FORMAT::EVOLUTION::PERCENTAGE_POINT")
      : "%";
    return (
      shorten(locale, evolution, 3, true, 1) +
      (evolution === Infinity ? "" : unit)
    );
  }
  return evolution > 0 ? "\u2B06" : "\u2B07";
};

interface EvolutionProps {
  evolution: number;
  knowable?: boolean;
  tinted?: boolean;
  theme: GlossyTheme;
}

const getColorFromEvolution = (props: EvolutionProps) => {
  if (props.tinted) {
    if (!isValid(props.evolution) && !props.knowable) return null;
    if (props.evolution === 0) return evolution(props, "stable");
    if (props.evolution > 0) return evolution(props, "up");
    return evolution(props, "down");
  }
  return content(props);
};

const Evolution = styled.span<EvolutionProps>`
  white-space: nowrap;
  color: ${(props) => getColorFromEvolution(props)};
  &.compact.unknown {
    display: none;
  }
`;

interface IProps {
  evolution: number;
  loading?: boolean;
  compact?: boolean;
  percentagePoint?: boolean;
  knowable?: boolean;
  tinted?: boolean;
  locale: Locale;
  className?: string;
}

const UiKitFormatEvolution = ({
  loading,
  locale,
  evolution,
  knowable = false,
  compact = false,
  percentagePoint = false,
  className,
  tinted = true,
}: IProps) =>
  loading ? null : (
    <Evolution
      evolution={evolution}
      knowable={knowable}
      tinted={tinted}
      className={className}
    >
      {formatEvolution(evolution, locale, knowable, compact, percentagePoint)}
    </Evolution>
  );

export default UiKitFormatEvolution;
